import Axios from 'axios';
import { grochatUrl } from '../config/serviceConfig';

const GetGrochat = (path, token) => {
    return Axios({
        method: 'GET',
        url: grochatUrl + path,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
}

export default GetGrochat;